import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, shadow, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'
const PAGE = 50

const ACTION_LABEL = {
  login: 'Giriş', login_failed: 'Başarısız giriş', logout: 'Çıkış',
  create: 'Oluşturma', update: 'Güncelleme', delete: 'Silme',
  toggle: 'Aktiflik', sync: 'Senkron', denied: 'Yetki reddi'
}
const STATUS_LABEL = { success: 'Başarılı', failed: 'Başarısız', denied: 'Reddedildi' }

const st = {
  card: { background: colors.bgCard, borderRadius: radius.lg, border: `1px solid ${colors.border}`, boxShadow: shadow.sm },
  input: s.input,
  label: s.label,
  th: { ...s.th, whiteSpace: 'nowrap' },
  td: { padding: '12px 16px', fontSize: '13px', color: colors.textPrimary, verticalAlign: 'top' }
}

function Badge({ text, ok }) {
  if (ok === undefined) return <span style={ui.chip}>{text}</span>
  return <span style={ui.status(ok)}><span style={ui.statusDot(ok)} />{text}</span>
}

function AuditLogs() {
  const { account } = useBrand()
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [offset, setOffset] = useState(0)
  const [loading, setLoading] = useState(true)
  const [meta, setMeta] = useState({ accounts: [], modules: [], brands: [] })
  const [expanded, setExpanded] = useState(null)
  const [f, setF] = useState({ from: '', to: '', account_id: '', brand_id: '', module: '', action: '', status: '', category: '', q: '' })

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  const fetchLogs = useCallback((off) => {
    setLoading(true)
    const params = { limit: PAGE, offset: off }
    Object.keys(f).forEach(k => { if (f[k]) params[k] = f[k] })
    axios.get(`${API}/admin/audit-logs`, { headers, params })
      .then(res => { setRows(res.data.rows); setTotal(res.data.total); setLoading(false) })
      .catch(() => setLoading(false))
  }, [f]) // eslint-disable-line

  useEffect(() => {
    if (account?.role !== 'super_admin') { navigate('/'); return }
    axios.get(`${API}/admin/audit-logs/meta`, { headers }).then(res => setMeta(res.data)).catch(() => {})
    fetchLogs(0)
  }, []) // eslint-disable-line

  function applyFilters() { setOffset(0); setExpanded(null); fetchLogs(0) }
  function clearFilters() {
    setF({ from: '', to: '', account_id: '', brand_id: '', module: '', action: '', status: '', category: '', q: '' })
    setOffset(0); setExpanded(null)
    setTimeout(() => fetchLogs(0), 0)
  }
  function goPage(dir) {
    const next = Math.max(0, offset + dir * PAGE)
    setOffset(next); setExpanded(null); fetchLogs(next)
  }

  const set = (k, v) => setF(p => ({ ...p, [k]: v }))
  const page = Math.floor(offset / PAGE) + 1
  const pages = Math.max(1, Math.ceil(total / PAGE))

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ ...s.pageTitle, margin: '0 0 4px' }}>Sistem Logları</h2>
          <p style={s.pageSubtitle}>Kullanıcı girişleri ve modül değişiklikleri — kim, ne zaman, nereden, ne yaptı.</p>
        </div>
        <button onClick={applyFilters} style={s.btnSecondary}>↻ Yenile</button>
      </div>

      {/* Filtreler */}
      <div style={{ ...st.card, padding: '16px', marginBottom: '16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
          <div><label style={st.label}>Başlangıç</label><input type="date" style={{ ...st.input, width: '100%' }} value={f.from} onChange={e => set('from', e.target.value)} /></div>
          <div><label style={st.label}>Bitiş</label><input type="date" style={{ ...st.input, width: '100%' }} value={f.to} onChange={e => set('to', e.target.value)} /></div>
          <div><label style={st.label}>Kullanıcı</label>
            <select style={{ ...st.input, width: '100%' }} value={f.account_id} onChange={e => set('account_id', e.target.value)}>
              <option value="">Tümü</option>
              {meta.accounts.map(a => <option key={a.account_id || a.account_email} value={a.account_id || ''}>{a.account_email}</option>)}
            </select>
          </div>
          <div><label style={st.label}>Marka</label>
            <select style={{ ...st.input, width: '100%' }} value={f.brand_id} onChange={e => set('brand_id', e.target.value)}>
              <option value="">Tümü</option>
              {meta.brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
          <div><label style={st.label}>Modül</label>
            <select style={{ ...st.input, width: '100%' }} value={f.module} onChange={e => set('module', e.target.value)}>
              <option value="">Tümü</option>
              {meta.modules.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div><label style={st.label}>İşlem</label>
            <select style={{ ...st.input, width: '100%' }} value={f.action} onChange={e => set('action', e.target.value)}>
              <option value="">Tümü</option>
              {Object.keys(ACTION_LABEL).map(a => <option key={a} value={a}>{ACTION_LABEL[a]}</option>)}
            </select>
          </div>
          <div><label style={st.label}>Durum</label>
            <select style={{ ...st.input, width: '100%' }} value={f.status} onChange={e => set('status', e.target.value)}>
              <option value="">Tümü</option>
              <option value="success">Başarılı</option>
              <option value="failed">Başarısız</option>
              <option value="denied">Reddedildi</option>
            </select>
          </div>
          <div><label style={st.label}>Kategori</label>
            <select style={{ ...st.input, width: '100%' }} value={f.category} onChange={e => set('category', e.target.value)}>
              <option value="">Tümü</option>
              <option value="normal">Normal</option>
              <option value="security">Güvenlik</option>
            </select>
          </div>
          <div><label style={st.label}>Ara (e-posta / özet / IP)</label><input style={{ ...st.input, width: '100%' }} value={f.q} onChange={e => set('q', e.target.value)} onKeyDown={e => e.key === 'Enter' && applyFilters()} placeholder="ara…" /></div>
        </div>
        <div className="sx-wrap" style={{ display: 'flex', gap: '10px', marginTop: '14px', flexWrap: 'wrap' }}>
          <button onClick={applyFilters} style={s.btnPrimary}>Filtrele</button>
          <button onClick={clearFilters} style={ui.btnQuiet}>Temizle</button>
        </div>
      </div>

      {/* Tablo */}
      <div style={{ ...st.card, overflow: 'hidden' }}>
        <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: `1px solid ${colors.border}`, flexWrap: 'wrap', gap: '10px' }}>
          <span style={{ fontSize: '13px', color: colors.textSecondary }}>Toplam <b style={ui.num}>{total.toLocaleString('tr-TR')}</b> kayıt</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <button onClick={() => goPage(-1)} disabled={offset === 0} style={{ ...ui.btnSm, cursor: offset === 0 ? 'default' : 'pointer', opacity: offset === 0 ? 0.4 : 1 }}>← Önceki</button>
            <span style={ui.numMuted}>{page} / {pages}</span>
            <button onClick={() => goPage(1)} disabled={offset + PAGE >= total} style={{ ...ui.btnSm, cursor: offset + PAGE >= total ? 'default' : 'pointer', opacity: offset + PAGE >= total ? 0.4 : 1 }}>Sonraki →</button>
          </div>
        </div>

        <div className="sx-scroll-x" style={{ overflowX: 'auto' }}>
          <table className="sx-cards" style={{ ...s.table, minWidth: '900px' }}>
            <thead>
              <tr>
                <th style={st.th}>Tarih / Saat</th>
                <th style={st.th}>Kullanıcı</th>
                <th style={st.th}>Modül</th>
                <th style={st.th}>İşlem</th>
                <th style={st.th}>Marka</th>
                <th style={st.th}>IP</th>
                <th style={st.th}>Tarayıcı</th>
                <th style={st.th}>Durum</th>
                <th style={st.th}></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={9} style={{ ...st.td, textAlign: 'center', padding: '40px', color: colors.textMuted }}>Yükleniyor…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={9} style={{ ...st.td, textAlign: 'center', padding: '40px', color: colors.textMuted }}>Kayıt bulunamadı.</td></tr>
              ) : rows.map(r => {
                const open = expanded === r.id
                return (
                  <React.Fragment key={r.id}>
                    <tr style={{ borderTop: `1px solid ${colors.border}`, background: r.category === 'security' ? colors.bgPage : colors.bgCard }}>
                      <td data-label="Tarih / Saat" style={{ ...st.td, whiteSpace: 'nowrap', color: colors.textSecondary }}>{new Date(r.created_at).toLocaleString('tr-TR')}</td>
                      <td data-label="Kullanıcı" style={st.td}>
                        <div style={{ fontWeight: 500 }}>{r.account_email || <span style={{ color: colors.textMuted }}>—</span>}</div>
                        {r.account_role && <div style={{ fontSize: '11px', color: colors.textMuted }}>{r.account_role === 'super_admin' ? 'Super Admin' : 'Marka Admin'}</div>}
                      </td>
                      <td data-label="Modül" style={st.td}>{r.module || '—'}</td>
                      <td data-label="İşlem" style={st.td}>
                        <Badge text={ACTION_LABEL[r.action] || r.action} />
                        <div style={{ fontSize: '12px', color: colors.textSecondary, marginTop: '4px', maxWidth: '260px', whiteSpace: 'normal' }}>{r.summary}</div>
                      </td>
                      <td data-label="Marka" style={{ ...st.td, color: colors.textSecondary }}>{r.brand_name || '—'}</td>
                      <td data-label="IP" style={{ ...st.td, whiteSpace: 'nowrap', fontFamily: 'monospace', fontSize: '12px', color: colors.textSecondary }}>
                        {r.ip || '—'}{r.country && <span style={{ marginLeft: '5px', color: colors.textMuted }}>{r.country}</span>}
                      </td>
                      <td data-label="Tarayıcı" style={{ ...st.td, color: colors.textSecondary, fontSize: '12px' }}>{r.browser !== 'Bilinmiyor' ? r.browser : '—'}{r.os && r.os !== 'Bilinmiyor' && <div style={{ color: colors.textMuted }}>{r.os}</div>}</td>
                      <td data-label="Durum" style={st.td}><Badge text={STATUS_LABEL[r.status] || r.status} ok={r.status === 'success'} /></td>
                      <td style={st.td}>
                        {(r.changes || r.entity_id || r.path) && (
                          <button onClick={() => setExpanded(open ? null : r.id)} style={ui.btnQuiet}>{open ? 'Gizle' : 'Detay'}</button>
                        )}
                      </td>
                    </tr>
                    {open && (
                      <tr style={{ background: colors.bgPage }}>
                        <td colSpan={9} style={{ padding: '14px 18px', borderTop: `1px solid ${colors.border}`, whiteSpace: 'normal' }}>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', fontSize: '12px' }}>
                            <div><span style={st.label}>Etkilenen kayıt</span>{r.entity_type || '—'}{r.entity_id ? ` #${r.entity_id}` : ''}{r.entity_label ? ` — ${r.entity_label}` : ''}</div>
                            <div><span style={st.label}>Kategori</span>{r.category === 'security' ? 'Güvenlik' : 'Normal'}</div>
                            <div><span style={st.label}>Endpoint</span><code className="sx-break" style={{ fontSize: '11px' }}>{r.method} {r.path}</code></div>
                            <div style={{ gridColumn: '1 / -1' }}><span style={st.label}>User-Agent</span><span className="sx-break" style={{ color: colors.textMuted, wordBreak: 'break-all' }}>{r.user_agent || '—'}</span></div>
                            {r.changes && (
                              <div style={{ gridColumn: '1 / -1' }}>
                                <span style={st.label}>Değişiklik (gönderilen değerler)</span>
                                <pre className="sx-scroll-x" style={{ margin: 0, padding: '10px 12px', background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.md, overflowX: 'auto', maxWidth: '100%', fontSize: '12px', lineHeight: 1.5 }}>{JSON.stringify(r.changes, null, 2)}</pre>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default AuditLogs
